'use strict';

import './CurrencyChoice.less';

import { CURRENCY } from 'ck-core/source/data/Currency';

import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import CurrencyPropType from './CurrencyPropType';
import SelectInput from 'ck-core-client/source/ui/form/SelectInput';

export default class CurrencyChoice extends React.Component {
	render() {
		const currencyChoices = [];
		for (let key in CURRENCY) {
			currencyChoices.push({
				key: CURRENCY[key],
				text: key
			});
		}

		const flagClasses = classnames('currency-flag', `currency-flag-${this.props.currency}`);

		return (
			<div className="CurrencyChoice">
				<div className={flagClasses} />
				<SelectInput
					name="currency"
					choices={currencyChoices}
					value={this.props.currency}
					onChange={this.props.handleChange}
				/>
			</div>
		);
	}
}

CurrencyChoice.propTypes = {
	currency: CurrencyPropType,
	handleChange: PropTypes.func.isRequired,
	disabled: PropTypes.bool
};
